export const SITE = {
  name: 'Doku Akustik A.Ş',
  brandShort: 'Doku Akustik',
  domain: 'https://akustikpanel.tr',
  phoneDisplay: '0850 480 25 34',
  phoneTel: '+908504802534',
  mobileDisplay: '0541 733 54 69',
  mobileTel: '+905417335469',
  officePhoneDisplay: '0 (216) 592 06 13',
  officePhoneTel: '+902165920613',
  whatsappDisplay: '0541 733 54 69',
  whatsappUrl: 'https://wa.me/905417335469',
  email: 'proje@tasarimakustik.com',
  showroom:
    'Osman Gazi Mahallesi Mimar Sinan Caddesi No:11/A Sancaktepe / İstanbul',
  factory: 'OSB Köşeler Mahallesi 3. Cadde No:20 M, Dilovası / Kocaeli',
} as const

export function canonical(path = '/') {
  if (path === '/') return `${SITE.domain}/`
  const clean = path.startsWith('/') ? path : `/${path}`
  return `${SITE.domain}${clean.endsWith('/') ? clean : `${clean}/`}`
}
